// extracted by mini-css-extract-plugin
module.exports = {"container":"pagination_container__3tJvZ","btn_pagination":"pagination_btn_pagination__37yqy","text":"pagination_text__3h5XT"};